import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Spin } from 'antd';
import { z } from 'zod';
import {
    ApiCompraClonarParamsAcao,
    queryOptionsCompraClonar,
} from '@/features/compra/api/apiCompraClonar';
import { CompraEditPage } from '@/features/compra/page/edit/CompraEditPage';
import { ErrorComponent } from '@/features/erro/components/ErrorComponent';
import { StringToIdpkSchema } from '@/std/schema';

const ParamsSchema = z.object({ idpk: StringToIdpkSchema });

const SearchSchema = z.object({
    formas_pagamento_gerar: z.enum(['S', 'N']),
    itens_atualizar: z.enum(['S', 'N']),
});

// biome-ignore assist/source/useSortedKeys: type inference
export const Route = createFileRoute('/a/compra/clonar/$idpk')({
    params: {
        parse: (params) => {
            const result = ParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
    validateSearch: SearchSchema,
    component: Component,
});

function Component() {
    const { idpk } = Route.useParams();
    const search = Route.useSearch();

    const { data, error, isPending } = useQuery(
        queryOptionsCompraClonar({
            idpk,
            params: {
                acao: ApiCompraClonarParamsAcao.Clonar,
                ...search,
            },
        }),
    );

    if (isPending) {
        return (
            <div className='flex min-h-[50vh] items-center justify-center'>
                <Spin size='large' />
            </div>
        );
    }

    if (error) {
        return <ErrorComponent error={error} />;
    }

    const compraClonada = data.registros[0];
    if (!compraClonada) {
        return <ErrorComponent error={new Error('A API não retornou os dados da nova compra.')} />;
    }

    return <CompraEditPage action='clonar' compraClonada={compraClonada} />;
}
